export default "__VITE_ASSET__B$DyTgfv__"